import * as React from 'react';

import { PageTitleBar } from 'components';

const WatermarkHeader = () => (
  <PageTitleBar
    showBackButton={false}
    headerTitle='تنظیمات نهان‌نگاری (Watermark)'
  />
);

export { WatermarkHeader };
